import {call, fork, put, take, takeEvery, takeLatest} from 'redux-saga/effects';

import {UserApi} from 'static/three-oh/src/modules/apis';
import {trackAuthenticatedUser, trackUnauthenticatedUser} from 'static/three-oh/utils/sessionActivity';

import * as actions from '../actions/userActions';
import * as types from './../constants/userActionTypes';


/*
 * Retreives the current user's data and records data in heap analytics
 */
export function * getCurrentUser(fromApi) {
  try {
    let data = window.user;
    if (!data || fromApi) {
      data = yield call(UserApi.getCurrentUser);
    }

    try {
      if (data.is_authenticated) {
        trackAuthenticatedUser(data);
      } else {
        trackUnauthenticatedUser(data);
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error('heap user tracking failed in userSagas - getCurrentUser(): ', error);
    }
    yield put(actions.loadUserSuccess(data));
  } catch (error) {
    yield put(actions.loadUserFailure(error));
  }
}

/*
 * Creates a new user
 */
export function * createNewUser(userInfo) {
  try {
    const result = yield call(UserApi.persistUser, userInfo);

    yield put(actions.loadUserSuccess(result));
  } catch (error) {
    yield put(actions.loadUserFailure(error));
  }
}

export function * watchGetCurrentUser() {
  yield take(types.USER_LOAD_REQUEST);
  yield call(getCurrentUser);
}

export function * watchCreateNewUser() {
  yield takeLatest(types.USER_CREATE_REQUEST, function * init(action) {
    const payload = {
      ...action.payload.additionalUserData,
      ...action.payload.userInfo
    };
    yield fork(createNewUser, payload);
  });
}

export function * watchRefreshCurrentUser() {
  yield takeEvery(types.USER_REFRESH_REQUEST, getCurrentUser, true);
}
